<template>
  <mf-loading-dialog :loading="$apollo.queries.campaign.loading || offerScheduleAndStaticSegmentsLoading">
    <edit
      v-if="editable"
      :campaign.sync="campaign"
      :offer-schedule="offerSchedule"
      :is-offer-schedule-permission-active="isOfferSchedulePermissionActive"
      :is-offer-schedule-personalized="isOfferSchedulePersonalized"
      :show-image.sync="showImage"
    />
  </mf-loading-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_GET_CAMPAIGN_BY_ID } from '../../graphql'
import offerScheduleCampaign from '@/modules/campanhas/views/mixins/offer-schedule-campaign.js'
import loadBenefitCampaignMixin from '@/modules/campanhas/cupom-desconto/mixins/load-benefit-campaign.js'

export default {
  name: 'PushCampaign',
  components: {
    Edit: () => import('@/modules/campanhas/campanhas-aplicativo/views/pages/Edit.vue'),
  },
  mixins: [offerScheduleCampaign, loadBenefitCampaignMixin],
  data: () => ({
    showImage: false,
    campaignId: '',
    campaign: {
      title: '',
      description: '',
      initial_date: '',
      final_date: '',
      products: [],
      segments: [],
      status: 'DRAFT',
      template_id: '',
      frequency: {
        type: 'ONETIME',
        interval: 0,
      },
      image_url: '',
      message: {
        send_date: '',
        send_time: '',
        title: '',
        text: '',
        inner_message_title: '',
        inner_message_text: '',
        innerMessage: false,
      },
      offers_schedule_id: '',
    },
  }),
  computed: {
    editable() {
      return ['DRAFT', 'SCHEDULED'].includes(this.campaign.status)
    },
    isAppCampaign() {
      return true
    },
  },
  apollo: {
    campaign: {
      query: QUERY_GET_CAMPAIGN_BY_ID,
      notifyOnNetworkStatusChange: true,
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
      update({ campaign }) {
        let newCampaign = cloneDeep(campaign)

        if (newCampaign && newCampaign.message) {
          if (newCampaign.message.inner_message_title || newCampaign.message.inner_message_text) {
            newCampaign.message.innerMessage = true
          } else {
            newCampaign.message.innerMessage = false
          }
        }

        if (newCampaign && newCampaign.segments) {
          newCampaign.segments = newCampaign.segments.map((segment) => {
            segment.updating = false
            return segment
          })
        }

        if (newCampaign?.offers_schedule && Object.entries(newCampaign.offers_schedule).length) {
          newCampaign = { ...newCampaign, offers_schedule_id: newCampaign.offers_schedule._id }
          this.offerSchedule = newCampaign.offers_schedule
        } else {
          newCampaign = { ...newCampaign, offers_schedule_id: '' }
          this.offerSchedule = {}
        }

        delete newCampaign.offers_schedule

        this.showImage = !!campaign.image_url

        // Inicializar targeting_mode se não estiver definido
        if (!newCampaign.targeting_mode) {
          newCampaign.targeting_mode = 'ALL'
        }

        return newCampaign || this.campaign
      },
      variables() {
        return {
          id: this.campaignId,
        }
      },
      skip() {
        if (!this.campaignId) return true
        return false
      },
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    $route(route) {
      if (route.params?.id?.length !== 24 && route.query?.quick_action) {
        // Reset the data
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
  },
  async mounted() {
    this.campaignId = this.$route.params.id
    if (this.campaignId?.length !== 24) this.campaignId = ''

    await this.loadBenefit({
      assignFieldsFn: ({ benefit, parsedSendDate, parsedFinalDate }) => {
        this.campaign.title = benefit.title
        this.campaign.description = benefit.description
        this.campaign.initial_date = parsedSendDate
        this.campaign.final_date = parsedFinalDate
        this.campaign.message.send_date = parsedSendDate
        this.campaign.image_url = benefit.image_url || ''
        this.showImage = !!benefit.image_url

        this.campaign.segments = (benefit.segmentsData || []).map((s) => ({
          ...s,
          clients_qty: s.clientsQty,
          clients_refreshed_at: s.clientsRefreshedAt,
        }))
      },
    })
  },
}
</script>
